import React, { useEffect, useRef, useState } from 'react';
import './Waveform.css';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Masonry from 'react-masonry-css';
import { storiesStyles } from './style';
import { getStoriesVideo } from '../services/storyService';
import AlignCenter from './AlignCenter';
import ProgressBar from '../components/ProgressBar';
import { dedupeStories, goFrontPage, goSingleStory, openLink, openShop } from '../utils';
import useTopDownPreloader from '../utils/useTopDownPreloader';
import hoverStyle from './hover.module.css';
import StoryDisplay from '../components/StoryDisplay';

const width = window.innerWidth;
const SCROLL_UNLOCK = 3;
const INITIAL_LIMIT = 30;

const StoriesVideo = () => {
	const navigate = useNavigate();
	const classes = storiesStyles();
	const [stories, setStories] = useState(null);
	const [scrollExtra, setScrollExtra] = useState(0);
	const sentinelRef = useRef(null);

	useEffect(() => {
		let cancelled = false;
		getStoriesVideo(res => {
			if (cancelled) return;
			setStories(dedupeStories(res?.results));
		});
		const timeout = setTimeout(() => {
			if (cancelled) return;
			setStories(prev => (prev === null ? [] : prev));
		}, 10000);
		return () => {
			cancelled = true;
			clearTimeout(timeout);
		};
	}, []);

	const eligibleLimit = INITIAL_LIMIT + scrollExtra;
	const visibleEnd = useTopDownPreloader(stories, eligibleLimit);

	useEffect(() => {
		if (!sentinelRef.current || !stories) return undefined;
		if (visibleEnd >= stories.length) return undefined;

		const obs = new IntersectionObserver(
			entries => {
				if (entries[0].isIntersecting) {
					setScrollExtra(prev => prev + SCROLL_UNLOCK);
				}
			},
			{ rootMargin: '300px' }
		);
		obs.observe(sentinelRef.current);
		return () => obs.disconnect();
	}, [visibleEnd, stories]);

	const visibleStories = stories ? stories.slice(0, visibleEnd) : [];

	return (
		<>
			<ProgressBar active={!stories || visibleEnd === 0} />
			<div>
				{stories && (
					<Masonry
						breakpointCols={1}
						className={classes.masonryGrid}
						columnClassName={classes.masonryGridColumn}
					>
						{visibleStories.map((item, i) => (
							<div key={i} className={hoverStyle.block1}>
								<AlignCenter>
									{item && item.vimeo_id && (
										<StoryDisplay
											story={item}
											onClick={() => goSingleStory(item.slug, navigate)}
											onLoad={null}
											eager
										/>
									)}
								</AlignCenter>
							</div>
						))}
					</Masonry>
				)}
				<div ref={sentinelRef} style={{ height: 1, width: '100%' }} />
				<Grid className={classes.centerText}>
					<Grid onClick={openShop} className={classes.rightText} style={{ right: width > 992 ? 20 : 0 }}>
						<Typography className={classes.text}>Shop</Typography>
					</Grid>
					<Grid
						onClick={() => openLink()}
						className={classes.leftText}
						style={{ left: width > 992 ? 20 : 0 }}
					>
						<Typography className={classes.text}>I Never Read,</Typography>
					</Grid>
					<Grid onClick={() => goFrontPage(navigate)} className={classes.bottomText}>
						<Typography className={classes.text}>Digital</Typography>
					</Grid>
				</Grid>
			</div>
		</>
	);
};

export default StoriesVideo;
